var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-wrapper"},[(_vm.fixedCalculation || _vm.fixedCalculationByRole)?_c('dashboard-fixed',{attrs:{"fixedCalculation":_vm.fixedCalculation}}):_c('dashboard-default')],1)}
var staticRenderFns = []

export { render, staticRenderFns }